// OK 30/10/2024

import { Facture } from "../interfaces";
import { FileInvoice } from "../interfaces/FileInvoice.interface";
import { ObjectId } from "../types";
import {  ip } from "./../utils/setup";

const INVOICE_API = `${ip}/api/Factures`;

// GET

export async function getInvoices(): Promise<Facture[]> {
    const response = await fetch(INVOICE_API, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur lors de la réception des factures");
  }
}

export async function getProfWaitings(): Promise<Facture[]> {
    const response = await fetch(`${INVOICE_API}/getProfWaitings`, {
        credentials: "include" 
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur lors de la réception des proformas");
    }
}

export async function getProfsWaitingCustomer(): Promise<Facture[]> {
    const response = await fetch(`${INVOICE_API}/getProfsWaitingCustomer`, {
        credentials: "include" 
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur lors de la réception des proformas");
    }
}
export async function getInvoicesWaitingPayment(): Promise<Facture[]> {
    const response = await fetch(`${INVOICE_API}/getInvoicesWaitingPayment`, {
        credentials: "include" 
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur lors de la réception des proformas");
    }
}

// GET ID

export async function getInvoice(_id: ObjectId): Promise<Facture> {
    const response = await fetch(`${INVOICE_API}/${_id}`, {
        credentials: "include" 
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur lors de la réception de la facture");
    }
}

export async function getFileInvoice(_id: ObjectId): Promise<FileInvoice> {
    const response = await fetch(`${INVOICE_API}/${_id}/getFile`, {
        credentials: "include" 
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur du serveur lors de la réception de la facture");
    }
}

// POST

export async function createInvoice(
  newInvoice: Partial<Facture>
): Promise<Facture> {
  const response = await fetch(INVOICE_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
       
    },
    body: JSON.stringify(newInvoice),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur lors de la création de la nouvelle facture");
  }
}

export async function createPDF(id: ObjectId) {
  const response = await fetch(`${INVOICE_API}/PDF`, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(id),
  });
  if (response.ok) {
  } else {
    throw new Error(
      "Erreur lors de la création de la nouvelle facture en version PDF"
    );
  }
}

export async function updatePDF(id: ObjectId) {
    const response = await fetch(`${INVOICE_API}/PDFUpdate`, {
        method: "POST",
        credentials: "include" ,
        headers: {
            "content-type": "application/json",
           
        },
        body: JSON.stringify(id),
    });
    if (response.ok) {
    } else {
        throw new Error(
            "Erreur lors de la création de la modification de la facture en version PDF"
        );
    }
}

// PUT

export async function updateInvoice(updateInvoice: Facture) {
  const { globalError, factProds, ...restInvoice } = updateInvoice;
  const response = await fetch(`${INVOICE_API}/${restInvoice.idFact}/getPDF`, {
      method: "PUT",
      credentials: "include" ,
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify(restInvoice),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition de la facture");
  }
}

export async function updateInvoiceMail(
    updateInvoice: Facture
): Promise<Facture> {
    const response = await fetch(
        `${INVOICE_API}/${updateInvoice.idFact}/updateInvoiceMail`,
        {
            method: "PUT",
            credentials: "include" ,
            headers: {
                "Content-Type": "application/json",
                
            },
            body: JSON.stringify(updateInvoice),
        }
    );
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur lors de l'édition de la facture");
    }
}

// DELETE

export async function deleteInvoice(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${INVOICE_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" ,
      
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression de la facture");
  }
}













